/**
 * This is table script.js file
 */

export default {
    name       : 'ElementListCell',
    /**
     * @override
     */
    data() {
        return {
            cols : []
        };
    },
    props : {
        item : {
            type     : Object,
            required : true
        },
        columns : {
            type     : Array,
            required : true
        }
    },
    /**
     * @override
     */
    mounted() {
        this.columns.forEach(element => {
            this.cols.push(this.item[element.field]);
        });
    }
};
